import { Navigate } from 'react-router';

import {
  ANY_SPORT_PLAY_BOARDS_ARENA,
  ANY_SPORT_PLAY_BOARDS_PRO,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { Mode } from '#src/components/pickers/ModePicker/index.tsx';
import { useLastVisitedBoardView } from '#src/hooks/useLastVisitedBoardView.ts';

const BoardsPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { lastVisitedView } = useLastVisitedBoardView();

  const isArenaMode =
    lastVisitedView?.lastVisitedMode === Mode.ARENA_CASH ||
    lastVisitedView?.lastVisitedMode === Mode.ARENA_ESSENCE;

  return (
    <Navigate
      to={generateSportContextPath(
        isArenaMode ? ANY_SPORT_PLAY_BOARDS_ARENA : ANY_SPORT_PLAY_BOARDS_PRO
      )}
      replace
    />
  );
};

export default BoardsPage;
